// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__WTB39","disabled":"Checkbox_disabled__M--lC"};